import { bootstrap } from './bootstrap'
import { eventBus, moduleLoader } from '../shared'

moduleLoader.initModuleByPriority(11, () => void bootstrap())

void eventBus.emit('eprivacy.cookie-banner.onetrust_assets-loaded')
void eventBus.emit('assets.module.loaded', {
  moduleId: 'eprivacy.cookie-banner.onetrust_assets',
})
